export class ErrorApp {
  status: number | string;
  message: string;
  tryAgain: boolean;
  fullError: any;

  constructor(status: number | string, message?: string) {
    this.status = status;
    this.message = message;
    this.tryAgain = false;
  }
}
